const theme = {
  panelBGColor: "rgba(0, 45, 116, 0.6)",
};

export { theme };